import React from 'react'
import "../css/normalize.css"
import "../css/style.css"
import "../css/all.min.css"
import { images } from './importingScript';

export default function Support() {
  return (
     <div className="features my-5 py-5"> 
      <div className="container text-center">
        <div className="row g-0 feature-row">
    
          {/* 1️⃣ Business Growth */}
          <div
            className="col-md-6 col-lg-3 wow fadeIn"
            data-wow-delay="0.1s"
            style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeIn' }}
          >
            <div className="feature-item border h-100 p-5">
              <div
                className="btn-square bg-light rounded-circle mb-4"
                style={{ width: '64px', height: '64px' }}
              >
                <img style ={{alignItems:'center'}}className="img-fluid" src={images['./about/icon-3.png']} alt="Icon" />
              </div>
              <h5 className="mb-3">Grow Your Business</h5>
              <p className="mb-0">
                Empower your brand with digital marketing, automation, and AI-powered strategies that attract more customers.
              </p>
            </div>
          </div>
    
          {/* 2️⃣ Expert Team */}
          <div
            className="col-md-6 col-lg-3 wow fadeIn"
            data-wow-delay="0.2s"
            style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeIn' }}
          >
            <div className="feature-item border h-100 p-5">
              <div
                className="btn-square bg-light rounded-circle mb-4"
                style={{ width: '64px', height: '64px' }}
              >
                <img className="img-fluid" src={images['./about/icon-1.png']} alt="Icon" />
              </div>
              <h5 className="mb-3">Professional Experts</h5>
              <p className="mb-0">
                Our skilled developers, marketers, and designers work together to deliver results that help your business grow faster.
              </p>
            </div>
          </div>
    
          {/* 3️⃣ Affordable Solutions */}
          <div
            className="col-md-6 col-lg-3 wow fadeIn"
            data-wow-delay="0.3s"
            style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeIn' }}
          >
            <div className="feature-item border h-100 p-5">
              <div
                className="btn-square bg-light rounded-circle mb-4"
                style={{ width: '64px', height: '64px' }}
              >
                <img className="img-fluid" src={images['./about/icon-4.png']} alt="Icon" />
              </div>
              <h5 className="mb-3">Affordable Solutions</h5>
              <p className="mb-0">
                We provide powerful tools, websites, and campaigns that fit every business size and budget — without compromise.
              </p>
            </div>
          </div>
    
          {/* 4️⃣ 24/7 Business Support */}
          <div
            className="col-md-6 col-lg-3 wow fadeIn"
            data-wow-delay="0.4s"
            style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeIn' }}
          >
            <div className="feature-item border h-100 p-5">
              <div
                className="btn-square bg-light rounded-circle mb-4"
                style={{ width: '64px', height: '64px' }}
              >
                <img className="img-fluid" src={images['./about/icon-2.png']} alt="Icon" />
              </div>
              <h5 className="mb-3">24/7 Business Support</h5>
              <p className="mb-0">
                We help you stay connected with your clients round the clock through AI chatbots, IVR systems, and automation tools.
              </p>
            </div>
          </div>
    
        </div>
      </div>
    </div>
  )
}